import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiClock, FiMail, FiMapPin } from 'react-icons/fi';
import { FaFacebook } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-container">
        <div className="footer-lead">
          <div>
            <span className="eyebrow eyebrow--light">Zmień czyjeś całe życie</span>
            <h2>Dom zaczyna się od spotkania.</h2>
          </div>
          <Link to="/dogs" className="button button--light">
            Poznaj podopiecznych <FiArrowUpRight aria-hidden="true" />
          </Link>
        </div>

        <div className="footer-grid">
          <div className="footer-about">
            <Link to="/" className="footer-brand">
              <img src="/logo.png" alt="" width="56" height="56" />
              <div><strong>Schronisko AZYL</strong><span>Dzierżoniów</span></div>
            </Link>
            <p>Od 1996 roku pomagamy bezdomnym zwierzętom odzyskać bezpieczeństwo i znaleźć kochające domy.</p>
            <a href="https://web.facebook.com/schroniskoazylddz/" target="_blank" rel="noopener noreferrer" className="footer-social">
              <FaFacebook aria-hidden="true" /> Facebook <FiArrowUpRight aria-hidden="true" />
            </a>
          </div>

          <div>
            <h3>Na skróty</h3>
            <nav className="footer-links" aria-label="Nawigacja w stopce">
              <Link to="/dogs">Psy do adopcji</Link>
              <Link to="/about">O schronisku</Link>
              <Link to="/support">Jak pomóc</Link>
              <Link to="/przetargi">Przetargi</Link>
            </nav>
          </div>

          <div>
            <h3>Odwiedź nas</h3>
            <div className="footer-contact">
              <div><FiMapPin aria-hidden="true" /><span>ul. Brzegowa 151<br />58-200 Dzierżoniów</span></div>
              <div><FiClock aria-hidden="true" /><span>Pon–Pt: 9:00–15:30<br />Sob: 9:00–14:00</span></div>
              <a href="mailto:kontakt@schroniskoazyl.eu"><FiMail aria-hidden="true" /><span>kontakt@schroniskoazyl.eu</span></a>
            </div>
          </div>

          <div className="footer-support">
            <h3>Wspieraj z nami</h3>
            <p>Przekaż 1,5% podatku i pomóż nam finansować leczenie oraz codzienną opiekę.</p>
            <span>KRS</span>
            <strong>0000062210</strong>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© 2026 Schronisko AZYL</span>
          <span>Stowarzyszenie Przyjaciół Zwierząt „Azyl”</span>
          <span>Projekt i realizacja <a href="https://abyssalechoes.com" target="_blank" rel="noopener noreferrer">Abyssal Echoes</a></span>
        </div>
      </div>
    </footer>
  );
}
